import styled from 'styled-components';
import theme from '../../theme';

const StyledTerms = styled.section`
    font-size:14px;
    font-weight:normal;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        margin:20px;
      };
      table{
          width:100% !important;
      }
      .terms{
        margin: 0px;
        list-style: none;
        padding: 0px;
          li{
            display: inline-block;
            padding: 15px 40px;
            color: ${(props) => props.theme.mediumGrey};
            font-size: 13px;
            cursor: pointer;
            @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
                width:33%;
                text-align:center;
                font-size:12px;
                padding:0px;
            };
            &.active{
                font-weight: 600;
                color: ${(props) => props.theme.primaryColor};
                background: ${(props) => props.theme.lightWhite};
                border:${(props) => props.theme.webGray} solid 1px;
                border-bottom: 0px;
                border-radius: 5px 5px 0px 0px;
            }
          }
      }
      .content{
        line-height: 26px;
        border:${(props) => props.theme.webGray} solid 1px;
        padding: 40px;
        color: ${theme.grayColor} !important;
        h1{
            font-size: 20px;
        }
        h4{
            line-height: 26px !important;
            color: ${theme.grayColor} !important;
            div{
            line-height: 26px !important;
            color: ${theme.grayColor} !important;
            li{
                line-height: 26px !important;
            color: ${theme.grayColor} !important;
            }
        }
        }
        
      }
    span{
        // display:block;
        // margin:0px 0px 20px 0px;
        strong{
            font-weight:normal;
        }
        b{
            margin:0px 20px;
        }
    }
    ol{
        margin:0px;
        padding:0px 0px 0px 20px;
        line-height:28px;
    }
    li.active {
        color: red;
    }
`;

export default StyledTerms;



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/StyledTerms.js